import { Action } from "@ngrx/store";
import { Menu } from "@edp-models/menu.model";
import { LasctActiveRoute } from "@edp-models/layout.model";

export enum ELayoutActions {
    OpenSidebar = "[Layout] Open Sidebar",
    CloseSidebar = "[Layout] Close Sidebar",
    SelectOverlay = "[Layout] Select Overlay",
    SelectSidebarSublevel = "[Layout] Select Sidebar Sublevel",
    ActiveItemSidebar = "[Layout] Active Item Sidebar",
    ShowLoader = "[Layout] Show Loader",
    SaveLastActiveRoute = "[Layout] Saving last active route",
    SetMainMenu = "[Layout] Set Main Menu",
    RefreshMainMenu = "[Layout] Refresh Main Menu",
    SetTabMenu = "[Layout] Set Active Tab Menu",
    SetActiveMenuItem = "[Layout] Set Active Menu Item",
    SetActiveSubMenuItem = "[Layout] Set Active submenu Item",
    LastResponse = "[Layout] Last Response",
    SetNeedLoadUserPoints = "[Layout] Set Need Load User Points",
    SetHeaderAlert = "[Layout] Set Header Alert"
}

export class OpenSidebarAction implements Action {
    public readonly type = ELayoutActions.OpenSidebar;
    constructor(public openSublevel: boolean = false) {}
}

export class CloseSidebarAction implements Action {
    public readonly type = ELayoutActions.CloseSidebar;
    constructor(public closeSublevel: boolean = false) {}
}

export class SelectOverlayAction implements Action {
    public readonly type = ELayoutActions.SelectOverlay;
    constructor(public payload: string, public origin?: string) {}
}

export class SelectSidebarSublevelAction implements Action {
    public readonly type = ELayoutActions.SelectSidebarSublevel;
    constructor(public payload: Menu[]) {}
}

export class ActiveItemSidebarAction implements Action {
    public readonly type = ELayoutActions.ActiveItemSidebar;
    constructor(public payload: string) {}
}

export class ShowLoader implements Action {
    public readonly type = ELayoutActions.ShowLoader;
    constructor(public loader: boolean) {}
}

export class SaveLastActiveRoute implements Action {
    public readonly type = ELayoutActions.SaveLastActiveRoute;
    constructor(public activeRoute: LasctActiveRoute) {}
}

export class SetMainMenu implements Action {
    public readonly type = ELayoutActions.SetMainMenu;
    constructor(public payload: Menu[]) {}
}

export class SetTabMenu implements Action {
    public readonly type = ELayoutActions.SetTabMenu;
    constructor(public payload: string) {}
}

export class RefreshMainMenu implements Action {
    public readonly type = ELayoutActions.RefreshMainMenu;
}

export class SetActiveMenuItem implements Action {
    public readonly type = ELayoutActions.SetActiveMenuItem;
    constructor(public payload: string) {}
}

export class SetActiveSubMenuItem implements Action {
    public readonly type = ELayoutActions.SetActiveSubMenuItem;
    constructor(public payload: string) {}
}

export class LastResponse implements Action {
    public readonly type = ELayoutActions.LastResponse;
    constructor(public response: boolean) {}
}

export class SetNeedLoadUserPoints implements Action {
    public readonly type = ELayoutActions.SetNeedLoadUserPoints;
    constructor(public payload: boolean) {}
}

export class SetHeaderAlert implements Action {
    public readonly type = ELayoutActions.SetHeaderAlert;
    constructor(public payload: boolean) {}
}

export type LayoutActions =
    | OpenSidebarAction
    | CloseSidebarAction
    | SelectOverlayAction
    | SelectSidebarSublevelAction
    | ActiveItemSidebarAction
    | ShowLoader
    | SaveLastActiveRoute
    | SetMainMenu
    | RefreshMainMenu
    | SetTabMenu
    | SetActiveMenuItem
    | SetActiveSubMenuItem
    | LastResponse
    | SetNeedLoadUserPoints
    | SetHeaderAlert;
